export const BUST_INT_TER: any[] = [
  {
    stopName: "S'pore Indoor Stadium",
    stopCode: '80199',
    stopLat: '1.3016',
    stopLon: '103.8751',
  },
  {
    stopName: 'Ang Mo Kio Bus Interchange',
    stopCode: '54009',
    stopLat: '1.369841',
    stopLon: '103.848094',
  },
  {
    stopName: 'Bedok Bus Interchange',
    stopCode: '84009',
    stopLat: '1.324553',
    stopLon: '103.929143',
  },
  {
    stopName: 'Bishan Bus Interchange',
    stopCode: '53009',
    stopLat: '1.35047',
    stopLon: '103.84978',
  },
  {
    stopName: 'Boon Lay Bus Interchange',
    stopCode: '22009',
    stopLat: '1.339132',
    stopLon: '103.705296',
  },
  {
    stopName: 'Bukit Batok Bus Interchange',
    stopCode: '43009',
    stopLat: '1.350008',
    stopLon: '103.750774',
  },
  {
    stopName: 'Bukit Merah Bus Interchange',
    stopCode: '10009',
    stopLat: '1.28208',
    stopLon: '103.817215',
  },
  {
    stopName: 'Bukit Panjang Bus Interchange',
    stopCode: '45009',
    stopLat: '1.378445',
    stopLon: '103.76284',
  },
  {
    stopName: 'Choa Chu Kang Bus Interchange',
    stopCode: '44009',
    stopLat: '1.385647',
    stopLon: '103.7453',
  },
  {
    stopName: 'Clementi Bus Interchange',
    stopCode: '17009',
    stopLat: '1.314793',
    stopLon: '103.764205',
  },
  {
    stopName: 'Compassvale Bus Interchange',
    stopCode: '67759',
    stopLat: '1.39122',
    stopLon: '103.89712',
  },
  {
    stopName: 'Eunos Bus Interchange',
    stopCode: '82009',
    stopLat: '1.31948',
    stopLon: '103.90166',
  },
  {
    stopName: 'HarbourFront Bus Interchange',
    stopCode: '14009',
    stopLat: '1.266777',
    stopLon: '103.819546',
  },
  {
    stopName: 'Hougang Central Bus Interchange',
    stopCode: '64009',
    stopLat: '1.37055',
    stopLon: '103.8923',
  },
  {
    stopName: 'Joo Koon Bus Interchange',
    stopCode: '24009',
    stopLat: '1.32697',
    stopLon: '103.6784',
  },
  {
    stopName: 'Jurong East Temporary Bus Interchange',
    stopCode: '28009',
    stopLat: '1.33325',
    stopLon: '103.742',
  },
  {
    stopName: 'Pasir Ris Bus Interchange',
    stopCode: '77009',
    stopLat: '1.373745',
    stopLon: '103.949681',
  },
  {
    stopName: 'Punggol Temporary Bus Interchange',
    stopCode: '65009',
    stopLat: '1.40443',
    stopLon: '103.90244',
  },
  {
    stopName: 'Sembawang Bus Interchange',
    stopCode: '58009',
    stopLat: '1.447427',
    stopLon: '103.819953',
  },
  {
    stopName: 'Sengkang Bus Interchange',
    stopCode: '67009',
    stopLat: '1.39174',
    stopLon: '103.89572',
  },
  {
    stopName: 'Serangoon Bus Interchange',
    stopCode: '66009',
    stopLat: '1.350799',
    stopLon: '103.872143',
  },
  {
    stopName: 'Tampines Bus Interchange',
    stopCode: '75009',
    stopLat: '1.354341',
    stopLon: '103.943616',
  },
  {
    stopName: 'Tampines Concourse Bus Interchange',
    stopCode: '75019',
    stopLat: '1.357283',
    stopLon: '103.941798',
  },
  {
    stopName: 'Toa Payoh Bus Interchange',
    stopCode: '52009',
    stopLat: '1.331623',
    stopLon: '103.847519',
  },
  {
    stopName: 'Woodlands Temporary Bus Interchange',
    stopCode: '46010',
    stopLat: '1.43739',
    stopLon: '103.78583',
  },
  {
    stopName: 'Yio Chu Kang Bus Interchange',
    stopCode: '55509',
    stopLat: '1.382573',
    stopLon: '103.844619',
  },
  {
    stopName: 'Yishun Bus Interchange',
    stopCode: '59008',
    stopLat: '1.427485',
    stopLon: '103.836293',
  },
  {
    stopName: 'Buona Vista Bus Terminal',
    stopCode: '11379',
    stopLat: '1.309416',
    stopLon: '103.79208',
  },
  {
    stopName: 'Changi Airport Bus Terminal',
    stopCode: '95129',
    stopLat: '1.356985',
    stopLon: '103.989906',
  },
  {
    stopName: 'Changi Business Park Bus Terminal',
    stopCode: '97009',
    stopLat: '1.341888',
    stopLon: '103.967137',
  },
  {
    stopName: 'Changi Village Bus Terminal',
    stopCode: '99009',
    stopLat: '1.38949',
    stopLon: '103.98791',
  },
  {
    stopName: 'Ghim Moh Bus Terminal',
    stopCode: '11009',
    stopLat: '1.31099',
    stopLon: '103.78924',
  },
  {
    stopName: 'Kampong Bahru Bus Terminal',
    stopCode: '10499',
    stopLat: '1.275969',
    stopLon: '103.83346',
  },
  {
    stopName: 'Kent Ridge Bus Terminal',
    stopCode: '16009',
    stopLat: '1.29444',
    stopLon: '103.76991',
  },
  {
    stopName: 'Lorong 1 Geylang Bus Terminal',
    stopCode: '80009',
    stopLat: '1.310304',
    stopLon: '103.871817',
  },
  {
    stopName: 'Marina Centre Bus Terminal',
    stopCode: '2099',
    stopLat: '1.29224',
    stopLon: '103.86166',
  },
  {
    stopName: 'Queen Street Bus Terminal',
    stopCode: '1109',
    stopLat: '1.303571',
    stopLon: '103.856509',
  },
  {
    stopName: 'Shenton Way Bus Terminal',
    stopCode: '3239',
    stopLat: '1.27429',
    stopLon: '103.84756',
  },
  {
    stopName: 'Sims Place Bus Terminal',
    stopCode: '80289',
    stopLat: '1.31608',
    stopLon: '103.87933',
  },
  {
    stopName: "St. Michael/'s Bus Terminal",
    stopCode: '52491',
    stopLat: '1.32597',
    stopLon: '103.855314',
  },
  {
    stopName: 'Tuas Bus Terminal',
    stopCode: '25009',
    stopLat: '1.34173',
    stopLon: '103.63953',
  },
  {
    stopName: 'Upper East Coast Bus Terminal',
    stopCode: '94009',
    stopLat: '1.317946',
    stopLon: '103.952805',
  },
];
